import { Typography } from "@mui/material";

const utils = {
  generate_regex: (search) =>
    new RegExp("(?=.*" + search.toLowerCase() + ")", "i"),
  formatTimestamp: (timestamp) => {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "";
    // Date only, numeric -> e.g. "12-05-2026"
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },
  formatString: function (input) {
    if (!input) {
      return "";
    }

    const segments = input.split(/\*\*(.*?)\*\*/);

    // Map over the segments
    const formattedSegments = segments.map((segment, index) => {
      // If the segment is between **, wrap it in a Typography component
      if (index % 2 !== 0) {
        return (
          <Typography key={index} variant="h6">
            {segment}
          </Typography>
        );
      }
      // Otherwise, return the segment as a string
      else {
        // Preserve the original formatting by splitting the segment into lines and wrapping each line in a <p> tag
        const lines = segment.split("\n").filter((line) => line.trim() !== "");
        return lines.map((line, i) => <p key={i}>{line}</p>);
      }
    });

    return formattedSegments;
  },

  createElementsFromString: function (str) {
    return str;
    // Split the string into parts by the "<br/>" delimiter
    const parts = str.split("<br/>");

    // Map each part to a JSX element
    const elements = parts.map((part, index) => {
      // If the part starts with "<Typography>", it's a Typography element
      if (part.trim().startsWith("<Typography")) {
        // Remove the "<Typography>" prefix and "</Typography>" suffix
        const text = part.trim().slice(25, -13);
        // Return a Typography element with the text as its children
        return (
          <Typography key={index} variant="h6">
            {text}
          </Typography>
        );
      }
      // Otherwise, it's a regular string
      else {
        // Split the string by spaces
        const words = part.split(" ");
        // Map each word to a <span> element
        const spans = words.map((word, i) => <span key={i}>{word}</span>);
        // Join the spans with space characters
        const joinedSpans = spans.reduce(
          (prev, curr, i) => (prev === null ? [curr] : [prev, " ", curr]),
          null
        );
        // Return a <p> element with the joined spans as its children
        return <p key={index}>{joinedSpans}</p>;
      }
    });

    // Return the array of elements
    return elements;
  },
};
export default utils;
